import { Component, OnInit, Input, Output, ContentChild, TemplateRef, EventEmitter, ViewContainerRef, ViewChild, ComponentFactoryResolver } from '@angular/core';

import { Principal } from '../../../services/auth/principal.service';
import { LoginService } from '../../../services/auth/login.service';
import { SubscriptionManager } from '../../../services/service/subscription-mamager';
import { UploadPhotoHelper } from '../../../services/helper/upload-photo.helper';
import { UserAvatorItem } from '../../model/user-avator-item';
import { UserCenterService } from '../../../services/service/user-center.service';

@Component({
    selector: 'zx-user-avator',
    templateUrl: './user-avator.component.html',
    styleUrls: ['./user-avator.component.css'],
})
export class UserAvatorComponent implements OnInit{
	@ViewChild('userCenterHost', {read: ViewContainerRef, static:true}) userCenterHost: ViewContainerRef
	isModalVisible = false;
	avatorColor = 'transparent';//['#f56a00', '#7265e6', '#ffbf00', '#00a2ae'][Math.ceil(Math.random()*3)+1];
	avatorPhoto;
	currentUser: any;
	component: any;

	@Input() showUserCenter:boolean = false;
	@Input() items:UserAvatorItem[] = [];
	@Output() toUserCenter:EventEmitter<any> = new EventEmitter();
  	@ContentChild('content', {static:true}) tpl_content: TemplateRef<void>;

	constructor(
		private subscriptionManager: SubscriptionManager,
		private uploadPhotoHelper: UploadPhotoHelper,
        private principal: Principal,
		private loginService: LoginService,
		private usercenterService: UserCenterService,
		private cfr: ComponentFactoryResolver
	) { }

	ngOnInit(){
		this.subscriptionManager.register(this, this.principal.authenticationStateChange.subscribe(a=>this.currentUser=a));
		this.principal.identity().then(account=>{
			this.setCurrentUser(account);
		});
		// 挂载个人中心组件
		setTimeout(() => {
			this.component = this.usercenterService.loadUserCenterComponent();
			if (this.component) this.userCenterHost.createComponent(this.cfr.resolveComponentFactory(this.component));
		}, 500)
	}
	ngOnDestroy(){
		this.subscriptionManager.unsubscribe(this);
	}

	setCurrentUser(v : any) {
		if(this.currentUser&&v&&this.currentUser.id==v.id) return;
		this.currentUser = v;
		if(v&&v.photo) this.avatorPhoto = this.uploadPhotoHelper.resolvePhotoUrl(v.photo);
	}
	goUserCenter(){
		if(this.showUserCenter) this.toUserCenter.emit();
	}
	logout(){
		this.loginService.logout();
	}
}